export default "__VITE_ASSET__DP2i2TvW__"